import React, {useState} from "react";
import {FilterSearchSortBar} from "./FilterSearchSortBar";
import {IconGrid} from "../icons/IconGrid";
import {FeaturedIconPackGrid} from "../icons/FeaturedIconPackGrid";
import {InfiniteLoader} from "./InfiniteLoader";
import {cn} from "../../lib/Utils";
import {LucideImage, LucideImages} from "lucide-react";

interface ViewSwitcherProps {
    activeView: string;
    setActiveView: (viewName: string) => void;
}

export const GridSwitcher: React.FC<ViewSwitcherProps> = ({activeView, setActiveView}: ViewSwitcherProps) => {
    const baseButtonClasses = "flex-1 py-2 px-4 rounded-md text-lg transition-all flex items-center justify-center gap-1";
    const activeButtonClasses = "bg-brand-500 text-surface-950 shadow-md shadow-brand-500/20 font-bold";
    const inactiveButtonClasses = "text-surface-300 font-medium hover:bg-surface-50/5 hover:text-surface-50";

    return (
        <div 
            id="grid-switcher"
            className="mmb-4 lg:mb-0 mx-auto lg:mx-0 flex-grow"
        >
            <div className="bg-surface-900 border border-brand-900 p-1 rounded-lg flex items-center gap-1 w-full min-w-[300px]">
                <button
                    className={cn(
                        baseButtonClasses,
                        activeView === "icons" ? activeButtonClasses : inactiveButtonClasses,
                    )}
                    onClick={() => setActiveView("icons")}
                >
                    <LucideImage size="20px" className="mr-2.5"/>icons
                </button>

                <button
                    className={cn(
                        baseButtonClasses,
                        activeView === "packs" ? activeButtonClasses : inactiveButtonClasses,
                    )}
                    onClick={() => setActiveView("packs")}
                >
                    {/*<LucideBlocks size="24px" className="mr-2.5"/>packs*/}
                    <LucideImages size="24px" className="mr-2.5"/>packs
                </button>
            </div>
        </div>
    );
};








